import { trackingService } from '@monthio/react-components'
import {
	BankError,
	BankToAdd,
	TransactionDataValidationStatus,
} from '#modules/Bank/Bank.types'
import { FetchBankSessionsTransactionsAction } from '../../actions/consumerDataPullSessionActions/fetchBankSessionsTransactions'

export enum FetchBankSessionsTransactionsStatus {
	IDLE = 'idle',
	FETCHING = 'fetching',
	FETCH_SUCCESS = 'fetchSuccess',
	FETCH_FAILURE = 'fetchFailure',
}

export interface FetchBankSessionsTransactionsState {
	status: FetchBankSessionsTransactionsStatus
	deselectedAccountIds: string[]
	fetchingTransactions: boolean
	succeeded: boolean
	error?: BankError
	shouldClearBudgetAndDebtData: boolean
	banksToAdd: BankToAdd[]
	TransactionDataValidation: TransactionDataValidationStatus
}

const INITIAL_STATE = {
	status: FetchBankSessionsTransactionsStatus.IDLE,
	deselectedAccountIds: [] as string[],
	fetchingTransactions: false,
	succeeded: false,
	shouldClearBudgetAndDebtData: false,
	banksToAdd: [] as BankToAdd[],
	TransactionDataValidation: {
		hasThreeMonthsOfTransactions: true,
		hasEnoughTransactionsLastMonth: true,
		hasEnoughTransactionsLastQuarter: true,
	} as TransactionDataValidationStatus,
}

export default function reduce(
	state: FetchBankSessionsTransactionsState = INITIAL_STATE, // skipcq: JS-0302
	action: FetchBankSessionsTransactionsAction,
): FetchBankSessionsTransactionsState {
	switch (action.type) {
		case 'transactionClientApp/fetchBankSessionsTransactions':
			return {
				...state,
				status: FetchBankSessionsTransactionsStatus.FETCHING,
				fetchingTransactions: true,
				deselectedAccountIds: action.deselectedAccountIds,
				succeeded: false,
			}
		case 'transactionClientApp/fetchBankSessionsTransactionsSucceeded':
			return {
				...state,
				status: FetchBankSessionsTransactionsStatus.FETCH_SUCCESS,
				fetchingTransactions: false,
				succeeded: true,
				shouldClearBudgetAndDebtData: action.shouldClearBudgetAndDebtData,
				banksToAdd: action.banksToAdd,
				TransactionDataValidation: action.TransactionDataValidation,
			}
		case 'transactionClientApp/fetchBankSessionsTransactionsFailed':
			if (
				action.fetchTransactionsError.name ===
					'FetchBankSessionsTransactionsFinishedReceivedNullResponse' &&
				state.error != null &&
				state.status === FetchBankSessionsTransactionsStatus.FETCH_FAILURE
			) {
				console.error(
					`[${new Date().toISOString()}] FetchBankSessionsTransactionsFinished received null response state already in error state`,
				)
				trackingService.trackTechnicalEvent(
					'FetchBankSessionsTransactionsFinishedReceivedNullResponse',
					action.fetchTransactionsError,
					{ source: 'transactionClientApp', treatAsError: true },
				)
				return state
			}
			return {
				...state,
				status: FetchBankSessionsTransactionsStatus.FETCH_FAILURE,
				error: action.fetchTransactionsError,
				fetchingTransactions: false,
			}
		case 'transactionClientApp/reopenConsumerDataPullSessionSucceeded':
			return {
				...state,
				status: FetchBankSessionsTransactionsStatus.IDLE,
				succeeded: false,
				error: undefined,
				fetchingTransactions: false,
			}
		case 'transactionClientApp/fetchBankSessionsTransactionsClearErrors':
			return {
				...state,
				error: undefined,
				status: FetchBankSessionsTransactionsStatus.IDLE,
			}
		default:
			return state
	}
}
